/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckSelfPublishFileRequest } from './deck-self-publish-file-request';

export interface PatchedDeckPitchSelfPublishDetailRequest {
  pitch_name?: string;
  company_name?: string | null;
  company_id?: string | null;
  paid?: boolean;
  accepted?: boolean;
  files?: Array<DeckSelfPublishFileRequest>;
}
